export default __webpack_public_path__ + "static/media/building@341.5e7925e2.jpg";